import React, { Component } from "react";
import "react-perfect-scrollbar/dist/css/styles.css";
import Router from "./router";
import { LocalStorageService } from "../services/localStorageService";
import WebsitesData from "./../Store/GlobalStates/WebsitesData";
import CannedMessagePersister from "./../Store/GlobalStates/CannedMessagePersister";
import { DetectEnvironment } from "../EnvironmentSettings";
import NewRelease from "../components/newRelease/newRelease";
import { utils } from "../utils";
import Loader from "react-loader-spinner";
import EventEmitter, { Events } from "../services/eventemitter"
import Stepper from "./Stepper";
import InternetStatus from "../components/internetStatus/internetStatus";



class AppComponent extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showPrompt: false,
            loader: false
        };

        this.checkInternetStatus()
        EventEmitter.on(Events.setLoader, this.setLoader)
    }

    setLoader = () => {
        this.setState({ loader: true })
    }

    checkInternetStatus = () => {
        window.localStorage.setItem("internetConnectivity", navigator.onLine as any)
    }


    fetchAppVersion = (): Promise<any> => {
        return fetch(`${process.env.PUBLIC_URL}/version.json`, { cache: "no-store" })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to fetch version.json: ${response.statusText}`);
                }
                return response.json();
            })
            .then((data) => {
                const appVersion = data?.version || "0.0.0";
                LocalStorageService.setLocalStorage("APP_VERSION", appVersion);
                return appVersion;
            })
            .catch((error) => {
                return null;
            });
    };


    addManifestFile = () => {
        var link = document.createElement("link");

        link.setAttribute("id", "2323");
        link.type = "json";
        link.rel = "manifest";
        link.href = "manifest/" + DetectEnvironment.config.REACT_APP_MANIFEST_CONFIGURATION;
        document.head.appendChild(link);
    }

    addFavicon = () => {
        const faviconPath = process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_FAVICONE; // Update with your actual favicon path
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = faviconPath;
        document.head.appendChild(link);
    }

    async componentDidMount() {
        window.myAPI?.getFCMToken('getFCMToken', (_, token) => { });

        var version = '0.0.0'
        if (!utils.isElectronBuild()) {
            let v = await this.fetchAppVersion()
            if (v != null && v) {
                version = v
            }
        }

        document.title = DetectEnvironment.config.REACT_APP_TAB_TITLE
        this.addManifestFile()
        this.addFavicon()

        window.addEventListener('beforeinstallprompt', e => {
            e.preventDefault();

            if ((navigator as any)?.getInstalledRelatedApps && !this.state.isCancelledInstallation) {
                (navigator as any)?.getInstalledRelatedApps()
                    .then(relatedApps => {
                        const isInstalled = relatedApps.some(app => app.id === process.env.REACT_APP_APP_ID);
                        if (isInstalled) {
                        } else { }
                    })
                    .catch(err => {
                        console.error('Error checking installed apps:', err);
                    });
            }
        })

        this.loadCssIntoDom("globalCss", "/css/" + DetectEnvironment.config.REACT_APP_STYLESHEET, version);
        // if(process.env.REACT_APP_TARGET_BUILD=='electron'){
        //        var console = (function (oldCons) {
        //         return {
        //             log: function (text) {
        //                 oldCons.log(text);
        //                 // console.log(text)
        //             },
        //             info: function (text) {
        //                 oldCons.log(text);

        //                 // console.info(text)
        //             },
        //             warn: function (text) {
        //                 // console.warn(text)
        //             },
        //             error: function (text) {
        //                 var currentData = new Date()
        //                 var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        //                 var errorText = `\n-----------------------------------------------------\nDate: ${currentData} \nUser Name: ${userData?.userLoginData?.username} \nError Details: ${text}`;
        //                 window?.myAPI?.saveErrorLog(errorText)

        //                 oldCons.error(text);
        //             }
        //         };
        //     }(window.console));

        //     window.console = console;
        // }


    }

    isDarkThemeRequested = () => {
        var value: string = localStorage.getItem("LayoutMode") ?? "layout-light";
        return value !== "layout-light";
    };

    loadCssIntoDom = (id: string, path: string, version: string) => {
        var existingElement = document.getElementById(id);

        if (existingElement != null) {
            return;
        }

        var link = document.createElement("link");

        link.setAttribute("id", id);
        link.type = "text/css";
        link.rel = "stylesheet";
        if (!utils.isElectronBuild()) {
            link.href = `${process.env.PUBLIC_URL}${path}?v=${version}`;
        } else {
            link.href = `${process.env.PUBLIC_URL}${path}`;
        }
        document.head.appendChild(link);
    }

    isTimeDifferenceGreaterThan8Hours = (date1, date2) => {
        const timeDifference = Math.abs(date1 - date2);
        const maxTimeDifference = 12 * 60 * 60 * 1000;
        return timeDifference > maxTimeDifference;
    }

    checkTokenExpire = () => {
        let currentDate = new Date();
        let otherDate = localStorage.getItem('loggedinTime') as any;

        if (otherDate) {
            otherDate = new Date(otherDate)
            const result = this.isTimeDifferenceGreaterThan8Hours(currentDate, otherDate);
            if (result) {
                window.localStorage.clear()
            }
        }
    }

    renderLoader = () => {
        return (<div
            className="release-down-progress"
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: '#f5f5f5', // Optional: Background for better visibility
            }}
        >
            <div className="body" style={{ display: 'flex', alignItems: 'center' }}>

                <div className="sweet-loading">
                    <Loader
                        type="ThreeDots"
                        color={"#FF586B"}
                    />
                </div>
            </div>
        </div>)

    }

    render() {
        // return <Stepper />
        if (this.state.loader) {
            return this.renderLoader()
        }
        else {
            this.checkTokenExpire();
            return (
                <>
                    <WebsitesData />
                    <InternetStatus />
                    <CannedMessagePersister />
                    <NewRelease />
                    <Router {...this.props} />
                </>
            );
        }
    }
}

export default AppComponent;
